var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 14.0625C8.32031 14.0625 5.15625 10.8984 5.15625 7.03125C5.15625 3.16406 8.32031 0 12.1875 0C16.0547 0 19.2188 3.16406 19.2188 7.03125C19.2188 10.8984 16.0547 14.0625 12.1875 14.0625ZM10.4297 17.3438H14.0039C14.5312 17.3438 15 17.8125 15 18.3984C15 18.6328 14.9414 18.8672 14.7656 19.043L13.125 20.918L14.9414 27.6562H15L17.0508 19.5703C17.168 19.043 17.6953 18.75 18.1641 18.9258C21.7969 20.2734 24.375 23.7891 24.375 27.9492C24.375 28.8281 23.6719 29.5312 22.793 29.5312H1.58203C0.703125 29.5312 0 28.8281 0 27.9492C0 23.7891 2.57812 20.2734 6.21094 18.9258C6.67969 18.75 7.20703 19.043 7.32422 19.5703L9.375 27.6562H9.43359L11.25 20.918L9.60938 19.043C9.49219 18.8672 9.375 18.6328 9.375 18.3984C9.375 17.8125 9.84375 17.3438 10.4297 17.3438Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOrange);
export default __webpack_public_path__ + "static/media/person-orange.9385164bf9d01347e5bec2cbd6f0a0c6.svg";
export { ForwardRef as ReactComponent };